import mixpanel from 'mixpanel-browser';
import { MIXPANEL_DEVICE_USER_LINK } from '../MixpanelDeviceUserLink/mixpanel_device_user_link';
import { loggedOutUser } from '../actions';

export const CASHCLEVER = 'CashClever';

// TO DO - we need process.env to determine which this is staging db or production.
// The endpoint should be from .env file and not here
const API_ENDPOINT_OBJECT = {
  development: `http://${window.location.hostname}:3000`,
  // staging: 'https://sagoi0o1l6.execute-api.us-east-1.amazonaws.com/stage',
  // production: 'https://sagoi0o1l6.execute-api.us-east-1.amazonaws.com/Stage',
  production: `https://${process.env.REACT_APP_ENV}.cashclever.net`,
};

export const API_ENDPOINT = API_ENDPOINT_OBJECT[process.env.NODE_ENV];
// console.log(window.location.hostname);
// API_ENDPOINT_OBJECT[process.env.NODE_ENV];
console.log(process.env.NODE_ENV);

// Routes NavBar
// export const pages = ['Products', 'Partner', 'Sign Up', 'Login'];
// export const settings = ['Home', 'Contact Us', 'Blogs', 'About Us'];

export const TOKEN = 'token';

export const PRODUCT = 'Products';
export const PARTNER = 'Partner';
export const SIGN_UP_NAVBAR = 'Sign Up';
export const LOGIN_NAVBAR = 'Login';

export const AUTO_LOANS = 'Auto Rates';
export const MORTGAGES = 'Mortgages';

export const HOMEPAGE = 'Home';
export const BLOGS = 'Blogs';
export const ABOUT_US = 'About';
export const CONTACT_US = 'Contact';
export const LOGOUT = 'Logout';
export const DASHBOARD = 'Dashboard';

export const NONLOGGED_IN_PAGES = [PRODUCT, PARTNER];
export const LOGGED_IN_PAGES = [PRODUCT, PARTNER];

export const NONLOGGED_IN_SETTINGS = [HOMEPAGE, BLOGS, ABOUT_US, CONTACT_US];
export const LOGGED_IN_SETTINGS = [HOMEPAGE, BLOGS, ABOUT_US, CONTACT_US, LOGOUT];

export const ALL_NON_LOGGED_IN_PAGES = [HOMEPAGE, ABOUT_US, AUTO_LOANS, MORTGAGES, LOGIN_NAVBAR];
export const ALL_LOGGED_IN_PAGES = [HOMEPAGE, ABOUT_US, AUTO_LOANS, MORTGAGES, DASHBOARD, LOGOUT];

export const PAGES_LINK_HREF_PATHS = {
  [HOMEPAGE]: '/',
  [PRODUCT]: '/',
  [PARTNER]: '/partner',
  [CONTACT_US]: '/contact',
  [ABOUT_US]: '/about',
  [SIGN_UP_NAVBAR]: '/signup',
  [LOGIN_NAVBAR]: '/login',
  [DASHBOARD]: '/dashboard',
  [AUTO_LOANS]: '/auto_rates',
  [MORTGAGES]: '/mortgages',
  [LOGOUT]: '/logout',
};

export const SETTINGS_LINK_HREF_PATHS = {
  [HOMEPAGE]: '/',
  [BLOGS]: '/',
  [ABOUT_US]: '/About',
  [CONTACT_US]: '/',
  [LOGOUT]: '/logout', // We should use an object to invoke a function here
};

export const handleSettingsClick = {
  [HOMEPAGE]: () => {},
  [BLOGS]: () => {},
  [ABOUT_US]: () => {},
  [CONTACT_US]: () => {},
  [LOGOUT]: async (dispatch, user) => {
    const anonymousDeviceId = mixpanel.get_distinct_id();
    if (
      user?.id &&
      MIXPANEL_DEVICE_USER_LINK?.[process.env.NODE_ENV]?.[anonymousDeviceId] === user?.id
    ) {
      const isUserAliasedAlready = localStorage.getItem(user.id);
      if (!isUserAliasedAlready) {
        mixpanel.alias(user.id);
        mixpanel.identify(user.id);
        localStorage.setItem(user.id, anonymousDeviceId);
      }
    }
    if (localStorage.getItem(TOKEN)) {
      mixpanel.track('Logout');
      mixpanel.reset();
    }

    localStorage.removeItem(TOKEN);
    await dispatch(loggedOutUser({ user }));
    window?.location?.reload();
  },
};

// Estimate Value Input
export const ENTER_PRICE_TAB_WRAPPER = 'enter-price-tab-wrapper';
export const DISPLAY_NONE = 'display-none';
export const ENTER_PRICE = 'Enter Price';

export const RESET_ALL = 'Reset All';
export const CHECK_RATES = 'Check Rates';
export const APPLY_CHANGES = 'Apply Changes';

export const FINANCE_AUTO_RATES = 'finance_auto_rates';
export const FINANCE_MORTGAGE_RATES = 'finance_mortgage_rates';

export const CHECK_RATES_PATH = {
  Auto: FINANCE_AUTO_RATES,
  Home: FINANCE_MORTGAGE_RATES,
};

export const EXPLORE_RATES = 'Explore Rates';

export const LOGIN_TO_EMAIL_RATES = 'Login To Email Rates';
export const HAVE_ACCOUNT = 'Have an account?';

export const SHOW_MONTHLY_PAYMENT = 'Monthly';
export const SHOW_TOTAL_PAYMENT = 'Total Pay';

export const SHOW_PAYMENT_OBJ = {
  [1]: SHOW_MONTHLY_PAYMENT,
  [0]: SHOW_TOTAL_PAYMENT,
};
